import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, AlertController, ViewController } from 'ionic-angular';
//import firebase from 'firebase';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { ViewContactPage } from '../view-contact/view-contact';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { SdfFormService } from '../../app/services/sdf-form-service';
import {EnvDataService} from '../../app/services/env-data-service';
/**
 * Generated class for the RealEstatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;

@Component({
  selector: 'page-real-estate',
  templateUrl: 'real-estate.html',
  providers:[EnvDataService]
})
export default class RealEstatePage {
  realEstateForm: FormGroup;
  public form_name: any;
  submitAttempt: boolean = false;
  public selected_type: any;
  public rand= new Date().getTime();
  public data: any;
  public allRealEstates: any;
  public allRealEstatess: any;
  public total_r_length: any;
  public edit_contact_uid: any;
  public total_length:any;
  public first_time_created: boolean = true;
  public contact_uid: any;
  public contact_second_uid: any;
  public userRole: any;
  public deleted_access:any;
  public get_secondary_percentage_asset: any;
  public max_percent: number = 100;
  public SDF_form_document_id: any;
  public document_id: any;
  public firstname: any;
  public lastname: any;
  public anotherApplicant: any;
  public secondary_uid: any;
  public realEstate_details: any;
  public new_val: any;
  public old_val: any;

  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol : ".",
    decimalLimit : 2,
    suffix: ' '
  });

  public validation_messages = {
    'asset_type': [
        { type: 'required', message: 'Asset type is required.' }
    ],
    'asset_value': [
      { type: 'required', message: 'Asset value is required.' }
    ],
    'value_basis': [
      { type: 'required', message: 'Value basis is required.' }
    ],
    'ownership_title_name': [
      { type: 'required', message: 'Ownership title name is required.' }
    ],
    'primary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'secondary_percentage_asset': [
      { type: 'required', message: 'Ownership percentage is required.' }
    ],
    'notes': [
      { type: 'required', message: 'Notes is required.' }
    ],
    'address_format': [
      { type: 'required', message: 'Address format is required.' }
    ],
    'street_number': [
      { type: 'required', message: 'Street Number is required.' }
    ],
    'street_name': [
      { type: 'required', message: 'Street Name is required.' }
    ],
    'street_type': [
      { type: 'required', message: 'Street Type is required.' }
    ],
    'city': [
      { type: 'required', message: 'City is required.' }
    ],
    'state': [
      { type: 'required', message: 'State is required.' }
    ],
    'postcode': [
      { type: 'required', message: 'Postcode is required.' }
    ],
    'country': [
      { type: 'required', message: 'Country is required.' }
    ],
    'gross_amount': [
      { type: 'required', message: 'Rental Income Per Week is required' }
    ],
    'creditor': [
      { type: 'required', message: 'Creditor is required.' }
    ],
    'mortgage_limit': [
      { type: 'required', message: 'Mortgage limit is required.' }
    ],
    'current_balance': [
      { type: 'required', message: 'Current balance is required.' }
    ],
    'loan_type': [
      { type: 'required', message: 'Load type is required.' }
    ],
    'repayments': [
      { type: 'required', message: 'Repayments is required.' }
    ],
    'interest_rate': [
      { type: 'required', message: 'Interest rate is required.' },
      { type: 'min', message: 'Interest rate minimum value 1.' },
      { type: 'max', message: 'Interest rate maximum value 100.' }
    ],
    'interest_rate_term': [
      { type: 'required', message: 'Interest rate term is required.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public modalCtrl: ModalController,
    public afAuth:AngularFireAuth,
    public http : Http,
    public loadingProvider: LoadingProvider,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public viewCtrl: ViewController,
    public SdfFormService: SdfFormService,
    public el: ElementRef,
    private EnvDataService:EnvDataService
  ) {

    this.realEstate_details = [];
    this.contact_second_uid = window.localStorage.getItem("contact_second_uid");
    this.userRole = window.localStorage.getItem("userRole");
    this.deleted_access = window.localStorage.getItem("deleted_access");
    if(this.contact_second_uid == "" || this.contact_second_uid == null || this.contact_second_uid == undefined){
      this.contact_second_uid = '';      
    }

    this.edit_contact_uid = this.navParams.get("edit_contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    if(this.edit_contact_uid == "" || this.edit_contact_uid == null || this.edit_contact_uid == undefined){
      this.edit_contact_uid = window.localStorage.getItem("edit_contact_uid");
    }

    this.editgetRealEstate(this.SDF_form_document_id).subscribe((data)=>{
      if(data.length > 0 && this.formArrRealEstates.length == 0){
        this.allRealEstatess = data;
        for(let j = 0; j < this.allRealEstatess.length; j++){
          this.editgetRealEstateSplit(this.allRealEstatess[j].document_id).subscribe((splitdata)=>{
            this.formArrRealEstates.controls[j].value['itemRowsMortgageSplits'].removeAt(0);
            let allSplitData = [];
            if(splitdata.length > 0 && this.formArrRealEstates.controls[j].value['itemRowsMortgageSplits'].length == 0){
              for(let l = 0; l < splitdata.length; l++){
                allSplitData.push(this.initItemRowsMortgageSplitLoad(splitdata[l]));
                this.formArrRealEstates.controls[j].value['itemRowsMortgageSplits'].push(this.initItemRowsMortgageSplitLoad(splitdata[l]));
              }
            }
          });
          this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.allRealEstatess[j]));
        }
      }
      this.anotherApplicant = [];
      this.secondary_uid = [];
      this.getRelatedSecondaryContacts(this.SDF_form_document_id).subscribe((data)=>{
        if(data.length > 0){
          for(let j = 0; j < data.length; j++){
            if(data[j].contact_type == 'Primary Contact'){
              this.firstname = data[j].firstname;
              this.lastname = data[j].lastname;
            }else{
              this.anotherApplicant.push({'firstname': data[j].firstname, 'lastname': data[j].lastname})
              this.secondary_uid.push({'uid': data[j].uid});
            }
          }
        }
      })
    })

    this.realEstateForm = formBuilder.group({
      itemRowsRealEstates: formBuilder.array([]),
      itemRowsMortgageSplits: formBuilder.array([])
    });

  }

  editgetRealEstate (SDF_form_document_id){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_realestate", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id )).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_realestate", ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
    }
  }
  editgetRealEstateSplit (mortgage_split_id){
    if(this.userRole == "super_admin" && this.deleted_access == 1){
      return this.db.collection<any>( "SDF_realestate/"+mortgage_split_id+"/mortgage_splits", ref => ref.orderBy('created_date' ) ).valueChanges ();
    }else{
      return this.db.collection<any>( "SDF_realestate/"+mortgage_split_id+"/mortgage_splits", ref => ref.where('deleted', '<', 1 ) ).valueChanges ();
    }
  }

  getRelatedSecondaryContacts (SDF_form_document_id){
    return this.db.collection<any>( "users_data", ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public scrollToFirstInvalidControl(formSlide){
    let firstInvalidControl = formSlide;
    const slideTab: HTMLElement = this.el.nativeElement.querySelector(
      ".bar-buttons.invalid button"
    );
    if(slideTab != null){
      slideTab.click();
    }
    let scrollContent: HTMLElement = this.el.nativeElement.querySelector(".scroll-content")
    scrollContent.scroll({
      top: this.getTopOffset(firstInvalidControl, scrollContent),
      left: 0,
      behavior: "smooth"
    });
    fromEvent(scrollContent, "scroll")
      .pipe(
        debounceTime(150),
        take(1)
      )
      .subscribe(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement, scrollContent: HTMLElement): number {
    const labelOffset = 100;
    return controlEl.getBoundingClientRect().top + scrollContent.scrollTop - labelOffset;
  }

  save(){
    this.submitAttempt = true;
    if(!this.realEstateForm.valid){
      this.realEstateForm.controls['itemRowsRealEstates']['controls'].forEach(formGroup => {
        this.markFormGroupTouched(formGroup);
      });


      // let formSelectorClass4_1: HTMLElement = this.el.nativeElement.querySelector(
      //   ".fifthSlideForm [formcontrolname].ng-invalid"
      // );
      // this.scrollToFirstInvalidControl(formSelectorClass4_1);

    }else{
      this.submitAttempt = false;
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      let contact_uid = window.localStorage.getItem("contact_uid");
      let contact_second_uid = window.localStorage.getItem("contact_second_uid");
      let brokerEmail = window.localStorage.getItem("email");
      let brokerFirstname = window.localStorage.getItem("brokerFirstname");

      let allRealEstates = this.realEstateForm.value;

      if(this.document_id == undefined){
        this.document_id = this.SDF_form_document_id;
      }

      if(uid != null){
        
        let postData = {
          "contact_uid": contact_uid,
          "SDF_form_document_id": this.SDF_form_document_id,
          "user_document_id": this.document_id,
          "reference_broker": uid,
          "primary_uid": contact_uid,
          "secondary_uid": this.secondary_uid,
          "document_id": this.document_id,
          "brokerEmail": brokerEmail,
          "brokerFirstname": brokerFirstname,
          "first_time_created": this.first_time_created,
          "realEstateForm" : allRealEstates,
          "realEstate_details": this.realEstate_details,
          "uid": uid
        }

        if(contact_second_uid == "" || contact_second_uid == null || contact_second_uid == undefined){
          postData['contact_second_uid'] = '';
        }else{
          postData['contact_second_uid'] = contact_second_uid;
        }

        if(allRealEstates.length > 0){
          postData['alread_added_or_not'] = 0;
        }else{
          postData['alread_added_or_not'] = 1;
        }

        postData['step'] = 5;
        this.SdfFormService.UpdateSDFForm(postData, postData);
        this.loadingProvider.stopLoading();
        this.navCtrl.push(ViewContactPage,{
          contact_uid: contact_uid, 
          SDF_form_document_id: this.SDF_form_document_id
        });
      }
    }
  }

  initItemRowsRealEstatesLoad(data) {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: [data.asset_type, Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: [data.asset_value, Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      ownership_title_name: [data.ownership_title_name, Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: [data.primary_percentage_asset, Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: [data.secondary_percentage_asset_0, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: [data.secondary_percentage_asset_1, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: [data.secondary_percentage_asset_2, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: [data.secondary_percentage_asset_3, Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: [data.secondary_percentage_asset_4, Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [data.notes],
      address_format: [data.address_format, Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: [data.floor_number, Validators.compose([Validators.maxLength(30)])],
      unit_number: [data.unit_number, Validators.compose([Validators.maxLength(30)])],
      building_name: [data.building_name, Validators.compose([Validators.maxLength(30)])],
      street_number: [data.street_number, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: [data.street_name, Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: [data.street_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: [data.city, Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: [data.state, Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: [data.postcode, Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: [data.country, Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: [data.gross_amount, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [data.deleted],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsMortgageSplitLoad(data) {
    return this.formBuilder.group({
      creditor: [data.creditor, Validators.compose([Validators.required, Validators.maxLength(30)])],
      mortgage_limit: [data.mortgage_limit],
      available_redraw: [data.available_redraw, Validators.compose([Validators.required, Validators.maxLength(30)])],
      current_balance: [data.current_balance, Validators.compose([Validators.required, Validators.maxLength(30)])],
      loan_type: [data.loan_type, Validators.compose([Validators.required, Validators.maxLength(30)])],
      repayments: [data.repayments, Validators.compose([Validators.required, Validators.maxLength(30)])],
      interest_rate: [data.interest_rate, Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
      interest_rate_term: [data.interest_rate_term, Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [data.document_id],
      deleted: [0]
    });
  }

  ionViewDidLoad() {
    
  }

  //real estate section
  get formArrRealEstates() {
    return this.realEstateForm.get('itemRowsRealEstates') as FormArray;
  }

  initItemRowsRealEstate() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      asset_type: ['Real Estate', Validators.compose([Validators.maxLength(30), Validators.required])],
      asset_value: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      value_basis: ['Applicant Estimate', Validators.compose([Validators.maxLength(30), Validators.required])],
      ownership_title_name: ['', Validators.compose([Validators.required, Validators.maxLength(200)])],
      primary_percentage_asset: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_0: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_1: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_2: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_3: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      secondary_percentage_asset_4: ['', Validators.compose([Validators.min(0), Validators.max(100)])],
      notes: [''],
      address_format: ['standard', Validators.compose([Validators.required, Validators.maxLength(30)])],
      full_address: [''],
      floor_number: ['', Validators.compose([Validators.maxLength(30)])],
      unit_number: ['', Validators.compose([Validators.maxLength(30)])],
      building_name: ['', Validators.compose([Validators.maxLength(30)])],
      street_number: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_name: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      street_type: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      state: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      postcode: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      country: ['Australia', Validators.compose([Validators.required, Validators.maxLength(30)])],
      gross_amount: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0],
      itemRowsMortgageSplits: this.formBuilder.array([this.initItemRowsRealEstateSplit()])
    });
  }

  initItemRowsRealEstateSplit() {
    return this.formBuilder.group({
        creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        mortgage_limit: [''],
        available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
        repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
        interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
        interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
        document_id: [''],
        deleted: [0]
      });
  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm '+status+' '+type,
      message: 'Are you sure you want to '+status+' this '+type+' ?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'collection': collection,
                    'deleted': deleted,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }else{
                  if(status == 'delete'){
                    if(type == 'real estate'){
                      this.formArrRealEstates.removeAt(index);
                    }
                  }
                }                
              }
          }
      ]
    });
    alert.present();
  }

  updateAndDeleteLoanSplit(parent_index: number, index: number, document_id: any, parent_document_id: any, status: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Loan Split',
      message: 'Are you sure you want to delete this Loan Split?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {

                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'parent_document_id' : parent_document_id,
                    'collection': 'SDF_realestate',
                    'deleted': deleted,
                    'parent_index': parent_index,
                    'index': index,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(this.userRole == "super_admin" && this.deleted_access == 1){
                      this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.value[index].deleted = 1;
                      this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits));
                    }
                    this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.removeAt(index);
                  }else{

                  }
                }else{
                  if(status == 'delete'){
                    this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.removeAt(index);
                  }
                }           
              }
          }
      ]
    });
    alert.present();
  }

  addRealEstates() {
    this.formArrRealEstates.push(this.initItemRowsRealEstate());
  }

  deleteRealEstates(index: number, document_id: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Real Estate',
      message: 'Are you sure you want to delete this Real Estate?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'document_id' : document_id,
                    'deleted_date' : new Date().getTime()
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/deleteRealEstate";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Deleted successfully.');
                      this.loadingProvider.stopLoading();
                      if(this.userRole == "super_admin" && this.deleted_access == 1){
                        this.formArrRealEstates.value[index].deleted = 1;
                        this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.value[index]));
                      }
                      this.formArrRealEstates.removeAt(index);
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }else{
                  this.formArrRealEstates.removeAt(index);
                }                
              }
          }
      ]
    });
    alert.present();
  }

  restoreRealEstate(index: number, document_id: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm restore Real Estate',
      message: 'Are you sure you want to restore this Real Estate?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'document_id' : document_id
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/restoreRealEstate";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Restore successfully.');
                      this.loadingProvider.stopLoading();
                      if(this.userRole == "super_admin" && this.deleted_access == 1){
                        this.formArrRealEstates.value[index].deleted = 0;
                        this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.value[index]));
                      }
                      this.formArrRealEstates.removeAt(index);
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }



  /*Mortgage limit new loan split*/
  get formArrMortgageSplits() {
    return this.realEstateForm.get('itemRowsMortgageSplits') as FormArray;
  }
  
  initItemRowsMortgageSplit() {
    return this.formBuilder.group({
      creditor: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      mortgage_limit: [''],
      available_redraw: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      current_balance: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      loan_type: ['Interest Only Loan', Validators.compose([Validators.required, Validators.maxLength(30)])],
      repayments: ['', Validators.compose([Validators.required, Validators.maxLength(30)])],
      interest_rate: ['', Validators.compose([Validators.required, Validators.maxLength(30), Validators.min(1), Validators.max(100)])],
      interest_rate_term: ['Fixed', Validators.compose([Validators.required, Validators.maxLength(30)])],
      document_id: [''],
      deleted: [0]
    });
  }

  addNewMortgageSplits(index) {
    this.formArrRealEstates.controls[index].value['itemRowsMortgageSplits'].push(this.initItemRowsMortgageSplit());
    //this.formArrMortgageSplits.push(this.initItemRowsMortgageSplit());
    //this.formArrRealEstates.push(this.formArrMortgageSplits);
    //console.log(this.formArrMortgageSplits);
  }

  deleteLoanSplit(parent_index: number, index: number, document_id: any, parent_document_id: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Loan Split',
      message: 'Are you sure you want to delete this Loan Split?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'document_id' : document_id,
                    'parent_document_id' : parent_document_id,
                    'deleted_date' : new Date().getTime(),
                    'collection' : 'SDF_realestate'
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/deleteLoanSplit";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Deleted successfully.');
                      this.loadingProvider.stopLoading();
                      if(this.userRole == "super_admin" && this.deleted_access == 1){
                        this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.value[index].deleted = 1;
                        this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits));
                      }
                      this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.removeAt(index);
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }else{
                  this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.removeAt(index);
                  //this.formArrMortgageSplits.removeAt(index);
                }                
              }
          }
      ]
    });
    alert.present();
  }

  restoreLoanSplit(parent_index: number, index: number, document_id: any, parent_document_id: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm restore Loan Split',
      message: 'Are you sure you want to restore this Loan Split?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'document_id' : document_id,
                    'parent_document_id' : parent_document_id,
                    'collection' : 'SDF_realestate'
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/restoreLoanSplit";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Restore successfully.');
                      this.loadingProvider.stopLoading();
                      if(this.userRole == "super_admin" && this.deleted_access == 1){
                        this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.value[index].deleted = 0;
                        this.formArrRealEstates.push(this.initItemRowsRealEstatesLoad(this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits));
                      }
                      this.formArrRealEstates.controls[parent_index].value.itemRowsMortgageSplits.removeAt(index);
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }
  /*End Mortgage limit new loan split*/

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  public changeAddressFormat($event, index){

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      console.log(e)
    }
  }

  codeInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  doClick(){
    this.viewCtrl.dismiss();
  }

  public changeOwnershipPercentage($event, index){
    let real_state_current_name = $event.ngControl.name;
    let get_secondary_percentage_asset_val = 0;    
    let get_primary_percentage_asset_val = 0;
    let get_primary_percentage_asset = this.realEstateForm.controls['itemRowsRealEstates'].value[index].get('primary_percentage_asset');
    get_primary_percentage_asset_val = get_primary_percentage_asset.value;
    if(this.contact_second_uid == "" || this.contact_second_uid == null || this.contact_second_uid == undefined){
      let total_percentage_asset = Number(get_primary_percentage_asset_val) + Number(get_secondary_percentage_asset_val);
      if(total_percentage_asset != 100 ){
        if(real_state_current_name == 'primary_percentage_asset'){
          this.max_percent = 100 - Number(get_secondary_percentage_asset_val);
          get_primary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
          get_primary_percentage_asset.updateValueAndValidity();
        }      
      }
    }else{
      this.get_secondary_percentage_asset = this.realEstateForm.controls['itemRowsRealEstates'].value[index].get('secondary_percentage_asset');
      get_secondary_percentage_asset_val = this.get_secondary_percentage_asset.value
      let total_percentage_asset = Number(get_primary_percentage_asset_val) + Number(get_secondary_percentage_asset_val);
      if(this.get_secondary_percentage_asset.value == "" || get_primary_percentage_asset.value == ""){}else{
        if(total_percentage_asset != 100 ){
          if(real_state_current_name == 'primary_percentage_asset'){
            this.max_percent = 100 - Number(get_secondary_percentage_asset_val);
            get_primary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
            get_primary_percentage_asset.updateValueAndValidity();
          }else{
            this.max_percent = 100 - Number(get_primary_percentage_asset_val);
            this.get_secondary_percentage_asset.setValidators([Validators.min(this.max_percent), Validators.max(this.max_percent)]);
            this.get_secondary_percentage_asset.updateValueAndValidity();
          }      
        }else{
          get_primary_percentage_asset.setValidators([Validators.min(get_primary_percentage_asset_val), Validators.max(get_primary_percentage_asset_val)]);
          get_primary_percentage_asset.updateValueAndValidity();
          this.get_secondary_percentage_asset.setValidators([Validators.min(get_secondary_percentage_asset_val), Validators.max(get_secondary_percentage_asset_val)]);
          this.get_secondary_percentage_asset.updateValueAndValidity();
        }
      }
    }
  }

  updateAddress(inputText, index){
    let addressInput = document.getElementById("address_"+this.rand+'_'+index);
    let autocomplete = new google.maps.places.Autocomplete(addressInput,
      {
          componentRestrictions: { country: 'AU' }
      });
      
      autocomplete.inputId = addressInput;
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
          const place = autocomplete.getPlace();
          let address_format = this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.address_format.value;
          let full_address = this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.full_address.value.split(' ');
          let full_address1 = full_address[0].split('/');
          if(full_address1.length == 1){
            full_address1 = full_address[0].split('-');
          }
          for (let i=0; i < place.address_components.length; i++){
            if (place.address_components[i].types[0] == "street_number") {
              if(place.address_components[i].long_name.search('/') >= 0 || place.address_components[i].long_name.search('-') >= 0){
                this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_number.setValue(place.address_components[i].long_name);
              }else if(full_address1.length > 1){
                if(address_format == 'nonStandard'){
                  this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_number.setValue(full_address[0]);
                  this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.unit_number.setValue(full_address1[0]);
                }else{
                  this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_number.setValue(full_address[0]);
                  this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.unit_number.setValue(full_address1[0]);
                }
              }else{
                this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_number.setValue(place.address_components[i].long_name);
              }
            }

            if (place.address_components[i].types[0] == "route") {
              let get_route = place.address_components[i].long_name;
              let type = place.address_components[i].long_name.split(" ");
              let typeName = type[type.length-1];
              let get_street_name = get_route.split(" "+typeName).join("");
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_name.setValue(get_street_name);
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.street_type.setValue(typeName.toUpperCase());

            }
            if (place.address_components[i].types[0] == "locality") {
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.city.setValue(place.address_components[i].long_name);
            }
            if (place.address_components[i].types[0] == "administrative_area_level_1") {
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.state.setValue(place.address_components[i].short_name);
            }
            if (place.address_components[i].types[0] == "country") {
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.country.setValue(place.address_components[i].long_name);
            }
            if (place.address_components[i].types[0] == "postal_code") {
              this.realEstateForm.controls['itemRowsRealEstates'].value[index].controls.postcode.setValue(place.address_components[i].long_name);
            }
          }
      });
  }


  realEstateLogData(event, type, index, split_index = -1){
    this.new_val = event.target.value.split("$").join("").split(",").join("");
    this.old_val = '';
    var property = '';
    if(type == 'available_redraw'){
      property = 'Funds in Offset or Redraw';
    }else if(type == 'gross_amount'){
      property = 'Gross Mortgage Amount';
    }else{
      property = type.split("_").join(" ").toUpperCase();
    }
    if(this.allRealEstatess != undefined){
      if(type == 'asset_value'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].asset_value != undefined){
          this.old_val = (this.allRealEstatess[index].asset_value.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].asset_value.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Asset Value';
      }
      if(type == 'gross_amount'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].gross_amount != undefined){
          this.old_val = (this.allRealEstatess[index].gross_amount.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].gross_amount.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Gross Mortgage Amount';
      }
      if(type == 'available_redraw'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].available_redraw.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].available_redraw.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Funds in Offset or Redraw';
      }

      if(type == 'current_balance'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].current_balance.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].current_balance.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Current Balance';
      }
      if(type == 'repayments'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].repayments.split("$").join("").split(",").join("") == undefined) ? '' : this.allRealEstatess[index].split[split_index].repayments.split("$").join("").split(",").join("");
        }else{
          this.old_val = '';
        }
        property = 'Repayments';
      }
    }  
    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : '$ '+this.formatMoney(this.old_val), 'new_value' : '$ '+this.formatMoney(this.new_val), 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }

  realEstateLogData1(event, type, index, split_index = -1){
    this.new_val = event._value;
    this.old_val = '';
    var property = type.split("_").join(" ").toUpperCase();
    if(this.allRealEstatess != undefined){
      if(type == 'ownership_title_name'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].ownership_title_name != undefined){
          this.old_val = (this.allRealEstatess[index].ownership_title_name == undefined) ? '' : this.allRealEstatess[index].ownership_title_name;
        }else{
          this.old_val = '';
        }
        property = 'Ownership Title Name';
      }
      if(type == 'primary_percentage_asset'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].primary_percentage_asset != undefined){
          this.old_val = (this.allRealEstatess[index].primary_percentage_asset == undefined) ? '' : this.allRealEstatess[index].primary_percentage_asset;
        }else{
          this.old_val = '';
        }
        property = 'Primary Percentage';
      }
      if(type == 'secondary_percentage_asset'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].secondary_percentage_asset != undefined){
          this.old_val = (this.allRealEstatess[index].secondary_percentage_asset == undefined) ? '' : this.allRealEstatess[index].secondary_percentage_asset;
        }else{
          this.old_val = '';
        }
        property = 'Secondary Percentage';
      }
      if(type == 'floor_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].floor_number == undefined) ? '' : this.allRealEstatess[index].floor_number;
        }else{
          this.old_val = '';
        }
        property = 'Floor Number';
      }
      if(type == 'unit_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].unit_number == undefined) ? '' : this.allRealEstatess[index].unit_number;
        }else{
          this.old_val = '';
        }
        property = 'Unit Number';
      }
      if(type == 'building_name'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].building_name == undefined) ? '' : this.allRealEstatess[index].building_name;
        }else{
          this.old_val = '';
        }
        property = 'Building Name';
      }
      if(type == 'street_number'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_number == undefined) ? '' : this.allRealEstatess[index].street_number;
        }else{
          this.old_val = '';
        }
        property = 'Street Number';
      }
      if(type == 'street_name'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_name == undefined) ? '' : this.allRealEstatess[index].street_name;
        }else{
          this.old_val = '';
        }
        property = 'Street Name';
      }
      if(type == 'city'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].city == undefined) ? '' : this.allRealEstatess[index].city;
        }else{
          this.old_val = '';
        }
        property = 'City';
      }

      if(type == 'postcode'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].postcode == undefined) ? '' : this.allRealEstatess[index].postcode;
        }else{
          this.old_val = '';
        }
        property = 'Postcode';
      }
      if(type == 'creditor'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].creditor == undefined) ? '' : this.allRealEstatess[index].split[split_index].creditor;
        }else{
          this.old_val = '';
        }
        property = 'Creditor';
      }
      if(type == 'interest_rate'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].interest_rate == undefined) ? '' : this.allRealEstatess[index].split[split_index].interest_rate;
        }else{
          this.old_val = '';
        }
        property = 'Interest Rate';
      }
    }
    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }

  collectRealestateLogData(event, type, index, split_index = -1){
    this.new_val = event.target.value;
    this.old_val = '';
    var property = type.split("_").join(" ").toUpperCase();
    if(this.allRealEstatess != undefined){
      if(type == 'asset_type'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].asset_type != undefined){
          this.old_val = (this.allRealEstatess[index].asset_type == undefined) ? '' : this.allRealEstatess[index].asset_type;
        }else{
          this.old_val = '';
        }
        property = 'Asset Type';
      }
      if(type == 'value_basis'){
        if(this.allRealEstatess.length > index && this.allRealEstatess[index].value_basis != undefined){
          this.old_val = (this.allRealEstatess[index].value_basis == undefined) ? '' : this.allRealEstatess[index].value_basis;
        }else{
          this.old_val = '';
        }
        property = 'Value Basis';
      }
      if(type == 'street_type'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].street_type == undefined) ? '' : this.allRealEstatess[index].street_type;
        }else{
          this.old_val = '';
        }
        property = 'Street Type';
      }
      if(type == 'state'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].state == undefined) ? '' : this.allRealEstatess[index].state;
        }else{
          this.old_val = '';
        }
        property = 'State';
      }
      if(type == 'country'){
        if(this.allRealEstatess.length > index){
          this.old_val = (this.allRealEstatess[index].country ==undefined) ? '' : this.allRealEstatess[index].country;
        }else{
          this.old_val = '';
        }
        property = 'Country';
      }
      if(type == 'loan_type'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].loan_type == undefined) ? '' : this.allRealEstatess[index].split[split_index].loan_type;
        }else{
          this.old_val = '';
        }
        property = 'Loan Type';
      }
      if(type == 'interest_rate_term'){
        if(this.allRealEstatess[index] > index && this.allRealEstatess[index].split.length > split_index){
          this.old_val = (this.allRealEstatess[index].split[split_index].interest_rate_term == undefined) ? '' : this.allRealEstatess[index].split[split_index].interest_rate_term;
        }else{
          this.old_val = '';
        }
        property = 'Interest Rate Term';
      }
    }

    if(this.new_val != this.old_val && property != ''){
      this.realEstate_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index, 'split_index' : split_index});
    }
    this.realEstate_details.sort((a,b)=>a.index > b.index);
  }

}


// WEBPACK FOOTER //
// ./src/pages/real-estate/real-estate.ts